import MediaLibrary from "@/components/feature/MediaLibrary";
import AdminModal from "@/pages/portal/admin/components/AdminModal";

interface MediaPickerModalProps {
  /** Bearer token for authenticated media listing. */
  token: string | null;
  /** The URL currently in use — highlighted so it's easy to spot. */
  currentUrl?: string;
  /** Called with the chosen file's public URL. */
  onSelect: (url: string) => void;
  /** Close the dialog. */
  onClose: () => void;
}

/**
 * Reusable "Choose from Media Library" picker.
 *
 * Thin wrapper around the shared Media Library — shows every uploaded image as a
 * thumbnail grid with search + folder filter so an admin can reuse an existing
 * file instead of uploading a duplicate.
 */
export default function MediaPickerModal({
  token,
  currentUrl,
  onSelect,
  onClose,
}: MediaPickerModalProps) {
  return (
    <AdminModal
      title="Choose from Media Library"
      subtitle="Pick an already-uploaded image to reuse it here."
      onClose={onClose}
      wide
    >
      <MediaLibrary
        token={token}
        scope="admin"
        mode="pick"
        currentUrls={currentUrl ? [currentUrl] : []}
        onSelect={(urls) => {
          if (urls[0]) onSelect(urls[0]);
          onClose();
        }}
        onCancel={onClose}
      />
    </AdminModal>
  );
}